
import Vue from "vue";

export default Vue.extend({
  model: {
    prop: "inputValue",
    event: "change"
  },
  props: {
    value: {
      default: null
    },
    inputValue: {
      default: undefined
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(value: any) {
      this.$emit("change", value);
    }
  }
});
